import React from "react";

const CheckCircle = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_2393_48908" fill="white">
        <path d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20Z" />
      </mask>
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20Z"
        fill="#EFF6FF"
        stroke="#DBEAFE"
        strokeWidth="2"
        mask="url(#path-1-inside-1_2393_48908)"
      />
      <circle cx="20" cy="20" r="20" fill="currentColor" />
      <path
        d="M13.3335 20.2398C13.579 20.6366 13.8847 20.9701 14.1433 21.3556C14.5176 21.9136 14.8927 22.4522 15.2876 22.9923C15.5431 23.3417 15.8191 23.6705 16.0363 24.0509C16.2165 24.3664 16.4879 24.7305 16.6098 25.0809C16.7087 25.365 16.8309 25.6324 16.9868 25.8878C17.2191 26.2683 17.8598 24.5747 17.932 24.4257C18.1371 24.0025 18.3364 23.5335 18.5905 23.141C19.7787 21.3055 21.4227 19.7292 22.9182 18.1968C24.1024 16.9834 25.4023 15.9395 26.6671 14.832"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CheckCircle;
